/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: jackbaeten (https://sketchfab.com/jackbaeten)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/macbook-pro-m3-16-inch-2024-8e34fc2b303144f78490007d91ff57c4
Title: macbook pro M3 16 inch 2024
*/

import { useGLTF, Html } from "@react-three/drei";
import { useResponsiveValues } from "../utils/responsiveValues";
import useHoverGlow from "../hooks/useHoverGlow";

export function MacBook2(props) {
  const { nodes, materials } = useGLTF("/models/macbook_pro.glb");
  //   console.log("materials", materials.sfCQkHOWyrsLmor);
  //   console.log("geometry", nodes.Object_123.geometry);
  const { macbook } = useResponsiveValues();

  // const { setHovered } = useHoverGlow(materials, "#ffffff10", 10);
  return (
    <group {...props} dispose={null} scale={0.1} position={[0, -1.5, 0]}>
      <group rotation={[Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_10.geometry}
          material={materials.AibnXCKcAbewWhH}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_12.geometry}
          material={materials.WeLyzRwUVIhQGgM}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_14.geometry}
          material={materials.UhoCLqHkvkDmxOA}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_16.geometry}
          material={materials.zhGRTuGrQoJflBD}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_18.geometry}
          material={materials.zCLdUynNQOzVMqx}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_20.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_22.geometry}
          material={materials.lmWQsEjxpsebDlK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_24.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_26.geometry}
          material={materials.MycfwscjQZRVSoj}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_28.geometry}
          material={materials.bsmYIMHYRqMuLqz}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_30.geometry}
          material={materials.LtEafgAVRolQqRw}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_32.geometry}
          material={materials.iyDJFXmHelnMTbD}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_34.geometry}
          material={materials.eJObPwhgFzvfaoZ}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_36.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_38.geometry}
          material={materials.nDsMUuDKliqGFdU}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_40.geometry}
          material={materials.LtEafgAVRolQqRw}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_42.geometry}
          material={materials.CRQixVLpahJzhJc}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_44.geometry}
          material={materials.IcpudUyxprDYhfw}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_46.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_48.geometry}
          material={materials.YYwBgwvcyZVOOAA}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_50.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_52.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_54.geometry}
          material={materials.SLGkCohDDelqXBu}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_56.geometry}
          material={materials.WDumMKBWVQxmraD}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_58.geometry}
          material={materials.WnHKXHhScfUbJQi}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_60.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_62.geometry}
          material={materials.ZNhRrZtaKWQYAab}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_64.geometry}
          material={materials.IcpudUyxprDYhfw}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_66.geometry}
          material={materials.fNHiBfcxHUJCahl}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_68.geometry}
          material={materials.bsEIHfblEXNcUMs}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_70.geometry}
          material={materials.CRQixVLpahJzhJc}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_72.geometry}
          material={materials.SABLxXNNESCdgUy}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_74.geometry}
          material={materials.LpqXZqhaGCeSzdu}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_76.geometry}
          material={materials.sIfSZcqgDlKMJPf}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_78.geometry}
          material={materials.bsmYIMHYRqMuLqz}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_80.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_82.geometry}
          material={materials.gMtYExgrEUqPfln}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_84.geometry}
          material={materials.WnHKXHhScfUbJQi}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_86.geometry}
          material={materials.nDsMUuDKliqGFdU}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_88.geometry}
          material={materials.bsEIHfblEXNcUMs}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_90.geometry}
          material={materials.uInNDOueKeBTGQB}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_92.geometry}
          material={materials.hmEmmncwVomyUTC}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_94.geometry}
          material={materials.WeLyzRwUVIhQGgM}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_96.geometry}
          material={materials.KclpPzxoRwZAoer}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_99.geometry}
          material={materials.wjAYtisbflXilXi}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_101.geometry}
          material={materials.zobIbiekuagXEVU}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_103.geometry}
          material={materials.RyKTMHTpkkwQkvB}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_105.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_107.geometry}
          material={materials.JvMFZolVCdpPqjj}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_109.geometry}
          material={materials.UBYmHfGRfHbOXyc}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_111.geometry}
          material={materials.uInNDOueKeBTGQB}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_113.geometry}
          material={materials.gOXiFODBFKnUyyU}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_115.geometry}
          material={materials.eBwkWuOBScacrgP}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_117.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_119.geometry}
          material={materials.jwuTsnFxKtBUxpK}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_121.geometry}
          material={materials.nDsMUuDKliqGFdU}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_123.geometry}
          material={materials.sfCQkHOWyrsLmor}
        >
          <Html
            transform
            wrapperClass="htmlScreen"
            //distanceFactor={macbook.distanceFactor}
            scale={1.34}
            position={[
              -0.0000324249267578125, -16.906499576568604, -11.749436855316162,
            ]}
            rotation={[-Math.PI / 1.635, 0, 0]}
            occlude
            style={{ pointerEvents: "auto" }}
          >
            <iframe
              src="https://3d-projects-beta.vercel.app/"
              className="screen-iframe"
              // onPointerEnter={() => setHovered(true)}
              // onPointerLeave={() => setHovered(false)}
            />
          </Html>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_125.geometry}
          material={materials.CdgEAaPUlrQWQuD}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_127.geometry}
          material={materials.ZCDwChwkbBfITSW}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_129.geometry}
          material={materials.XCYkeTCxqFmKTKe}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Object_131.geometry}
          material={materials.MycfwscjQZRVSoj}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/models/macbook_pro.glb");

export default MacBook2;
